import React from "react";
import ReactDOM from "react-dom";
import { ModalContext } from "./modalContext";
import { Button } from "gumdrops";

const ModalWrapper = () => {
  let { modalContent, handleModal, modal } = React.useContext(ModalContext);
  if (modal) {
    return ReactDOM.createPortal(
      <div
        className="gds-modal__overlay gds-modal--shown"
        style={{ zIndex: 10000 }}
      >
        <div className="gds-modal gds-layout__column--md-8">
          <div className="gds-modal__wrapper">
            <div className="gds-modal__header gds-modal__header--sm">
              <div className="gds-modal__title">{modalContent.title}</div>
              <button
                className="gds-modal__close-button"
                onClick={() => handleModal()}
              ></button>
            </div>
            <div className="gds-modal__content">{modalContent.content}</div>
            <div className="gds-flex gds-flex--justify-end -p-h-3 -p-b-2">
              <Button context="outline" size="sm" onClick={() => handleModal()}>
                Cancel
              </Button>
              <Button
                className="-m-l-2"
                context="primary"
                size="sm"
                onClick={() => handleModal()}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>
      </div>,
      document.querySelector("#modal-root")
    );
  } else return null;
};

export default ModalWrapper;
